import React from "react";
import "../../Css/HomePage/HomeFacililities.css";
import PickUpDrop from "../../Images/logo/transporting.png";
import ParkingSpace from "../../Images/logo/parking-area.png";
import RoomService from "../../Images/logo/bed.png";
import SwimmingPool from "../../Images/logo/swimming-pool.png";
import FibreInternet from "../../Images/logo/internet.png";
import Breakfast from "../../Images/logo/breakfast.png";
import { IoBedOutline } from "react-icons/io5";
import { FaParking } from "react-icons/fa";
import { FaSwimmingPool } from "react-icons/fa";
import { IoWifi } from "react-icons/io5";
import { MdOutlineFreeBreakfast } from "react-icons/md";
import { MdOutlineKingBed } from "react-icons/md";
import { Slide } from "react-awesome-reveal";

const HomeFacilites = () => {
  return (
    <>
      <section className="home-section-facilites" id="facilities">
        <div className="container">
          <div className="home-section-facilites-main-con">
            <div className="home-section-facilites-main-head">
              <h2>Our Services</h2><br className="d-none d-sm-block"/>
              <h3>Hotel Facilities</h3>
            </div>
            <div className="row">
            <div className="col-md-4">
              <Slide>
                <div className="home-section-facilites-card-main-con">
                  <div className="home-section-facilites-card-details">
                    <div className="home-section-facilites-card-icons">
                      {/* <img src={RoomService} alt="PickUpDrop" /> */}
                      <IoBedOutline size={50} color="darkgreen"/>

                    </div>
                    <h3>Room Service</h3>
                    <p>
                    Enjoy attentive room service that caters to your needs, making your stay as comfortable and convenient as possible.
                    </p>
                  </div>
                </div>
                </Slide>
              </div>

              <div className="col-md-4">
                <Slide direction="up" triggerOnce={true}>
                <div className="home-section-facilites-card-main-con">
                  <div className="home-section-facilites-card-details">
                    <div className="home-section-facilites-card-icons">
                      {/* <img src={ParkingSpace} alt="PickUpDrop" /> */}
                      <FaParking  size={50} color="darkgreen"/>

                    </div>
                    <h3>Parking Space</h3>
                    <p>
                    We offer convenient parking space for our guests, ensuring a hassle-free arrival and departure.
                    </p>
                  </div>
                </div>
                </Slide>
              </div>

              

              <div className="col-md-4">
                <Slide direction="right">
                <div className="home-section-facilites-card-main-con">
                  <div className="home-section-facilites-card-details">
                    <div className="home-section-facilites-card-icons">
                      {/* <img src={SwimmingPool} alt="PickUpDrop" /> */}
                      <FaSwimmingPool   size={50} color="darkgreen"/>

                    </div>
                    <h3>Swimming Pool</h3>
                    <p>
                    Relax and unwind at the resort’s inviting Swimming Pool, offering a tranquil oasis with crystal-clear waters and a serene ambiance.
                    </p>
                  </div>
                </div>
                </Slide>
              </div>

              <div className="col-md-4">
                <Slide>
                <div className="home-section-facilites-card-main-con">
                  <div className="home-section-facilites-card-details">
                    <div className="home-section-facilites-card-icons">
                      {/* <img src={FibreInternet} alt="PickUpDrop" /> */}
                      <IoWifi   size={50} color="darkgreen"/>

                    </div>
                    <h3>Fibre Internet</h3>
                    <p>
                    Stay connected with our high-speed fiber internet, ensuring seamless browsing and streaming throughout your stay.
                    </p>
                  </div>
                </div>
                </Slide>
              </div>

              <div className="col-md-4">
                <Slide direction="up" triggerOnce={true}>
                <div className="home-section-facilites-card-main-con">
                  <div className="home-section-facilites-card-details">
                    <div className="home-section-facilites-card-icons">
                      {/* <img src={Breakfast} alt="PickUpDrop" /> */}
                      <MdOutlineFreeBreakfast   size={50} color="darkgreen"/>

                    </div>
                    <h3>Breakfast</h3>
                    <p>
                    Start your day with a delicious Breakfast in the Resort Room, featuring a variety of freshly prepared dishes to suit every taste.
                    </p>
                  </div>
                </div>
                </Slide>
              </div>
              <div className="col-md-4">
                <Slide direction="right">
                <div className="home-section-facilites-card-main-con">
                  <div className="home-section-facilites-card-details">
                    <div className="home-section-facilites-card-icons">
                      {/* <img src={RoomService} alt="PickUpDrop" /> */}
                      <MdOutlineKingBed   size={50} color="darkgreen"/>

                    </div>
                    <h3>King Bed Room </h3>
                    <p>
                    Our King Bed Room offers a perfect blend of comfort and elegance, featuring a luxurious king-sized bed with premium linens, a spacious layout, and modern amenities.                     </p>
                  </div>
                </div>
                </Slide>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeFacilites;
